import { Component, Inject, ViewChild } from '@angular/core';
import {
  AdditionalInfo,
  IAdditionalInfo,
} from '@secca/shared/interfaces/additional-info';
import { IMinimizable } from '@secca/shared/interfaces/minimizable';
import { IKeyboardEnabled } from '@secca/shared/interfaces/keyboard-enabled';
import { IFocusEnabled } from '@secca/shared/interfaces/focus-enabled';
import { DialogMinimizableDirective } from '@secca/shared/directives/dialog-minimizable.directive';
import { MinimizableDialogType } from '@secca/shared/enums/minimizable-dialog-type-enum';
import { DialogSelectableDirective } from '@secca/shared/directives/dialog-selectable.directive';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBoundryService } from '@secca/core/services/dialog-boundry.service';
import { DialogHelperUtilService } from '@secca/core/services/dialog-helper-util.service';
import { SplitDialogData } from '@secca/case/components/case-economy/case-economy-coordination-case-split/split-dialog-data.component';
import { CoordinationCaseSplitComponent } from '@secca/case/components/case-economy/case-economy-coordination-case-split/coordination-case-split/coordination-case-split.component';

@Component({
  selector: 'app-case-economy-coordination-case-split-dialog',
  templateUrl: './split-dialog.component.html',
  styleUrls: ['./split-dialog.component.scss'],
  standalone: false,
})
export class SplitDialogComponent implements IAdditionalInfo, IMinimizable, IKeyboardEnabled, IFocusEnabled {
  @ViewChild(DialogMinimizableDirective) minimizedDirective: DialogMinimizableDirective;
  @ViewChild(CoordinationCaseSplitComponent) wrappedInstance: CoordinationCaseSplitComponent;
  @ViewChild(DialogSelectableDirective) selectableDirective: DialogSelectableDirective;

  constructor(private dialogRef: MatDialogRef<SplitDialogComponent>,
              public dialogBoundryService: DialogBoundryService,
              private dialogHelperUtilService: DialogHelperUtilService,
              @Inject(MAT_DIALOG_DATA) data: SplitDialogData,
              ) {
    this.data = data;
  }

  data: SplitDialogData;

  getFocusElement() {
    return this.selectableDirective?.focusElement;
  }

  keyboardClose(): void {
    this.wrappedInstance.close();
  }

  minimize(): void {
    this.minimizedDirective.minimize();
  }

  getMinimizeType(): MinimizableDialogType {
    return this.minimizedDirective.appDialogMinimizable;
  }

  close() {
    this.dialogHelperUtilService.close(this.dialogRef, Number(this.data.caseId), true);
  }

  get MinimizableDialogType() {
    return MinimizableDialogType;
  }

  getAdditionalInfo(): AdditionalInfo {
    const caseId: number = this.data?.caseId;
    const caseNumber: string = this.data?.caseNumber;
    const supplierInvoiceId: number = this.data?.supplierInvoiceId;

    return {
      caseId,
      hoverTitle: caseNumber || '',
      hoverText: 'Split invoice: '+supplierInvoiceId || ''
    };
  }
}

